/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path hooks
 * @description Range context
 */
import React from "react";
import { useRanges } from "./../apihooks/useRanges";
import { useAppContext } from "./../context/AppCtxProvider";
const noDataKPI = {
  name: "No Data",
  maxseriesid: "noData",
  maxbelongstorange: "noData",
  minseriesid: "noData",
  minbelongstorange: "noData",
  rangevalue: undefined,
  color: "000000",
};
const noDataProject = {
  name: "not-started",
  maxseriesid: "notStarted",
  maxbelongstorange: "notStarted",
  minseriesid: "notStarted",
  minbelongstorange: "notStarted",
  rangevalue: undefined,
  color: "000000",
};
const useRangeContext = (valueSetting: string = "KPI") => {
  const ctx = useAppContext();
  const shouldLoadRanges =
    ctx.page !== "reporttemplates" && ctx.page !== "configurablereports";
  const { data, isSuccess } = useRanges(
    shouldLoadRanges ? ctx.elementId : undefined,
    true,
    5,
    `typename="${valueSetting}"`
  );
  React.useEffect(() => {
    if (isSuccess && data) {
      const ranges = [
        ...data.data,
        valueSetting === "KPI" ? noDataKPI : noDataProject,
      ];
      const hasDuplicate: Record<string, boolean> = {};
      const filteredRanges = ranges.filter((r) => {
        const condition = !!hasDuplicate[r.name];
        hasDuplicate[r.name] = true;
        return !condition;
      });
      ctx.sendValue("ranges", filteredRanges);
      ctx.sendValue("selectedRanges", filteredRanges);
      // console.log('ranges ', data.data);
    }
  }, [data]);
};
export default useRangeContext;
